export default __webpack_public_path__ + "static/media/BrowserSupportIcon.af38f88a.svg";